import React from 'react';
import { Link } from 'react-router-dom';

function HotelConfig() {
  return (
    <div className="flex bg-white min-h-screen">
      {/* Sidebar */}
      <div className="w-1/5 bg-gray-100 border-r text-black hover:text-gray-800 p-4">
        <h1 className="text-xl font-bold mb-4">Settings</h1>
        <div>
          {/* Sidebar Links */}
          <Link
            to="/dashboard/system-config/wide-settings"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            General
          </Link>
          <Link
            to="/dashboard/system-config/preferences"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Preferences
          </Link>

          <Link
            to="/dashboard/system-config/notifications"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Notifications
          </Link>

          <Link
            to="/dashboard/system-config/language"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Language Settings
          </Link>

          <Link
            to="/dashboard/system-config/currency"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Currency Settings
          </Link>

          <Link
            to="/dashboard/system-config/hotel-config"
            className="w-full block text-left py-2 px-4 mb-2 rounded bg-black text-white "
          >
            Hotel Configuration
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-5/6 bg-white p-8">
        {/* Header */}
        <div className="mb-9 flex justify-between items-center">
          <div>
            <h2 className="text-2xl text-black font-bold">Settings &gt; Hotel Config</h2>
            <p className="text-gray-500 font-semibold">
              Get Notified about what's happening right now.
            </p>
          </div>
          <div className="flex space-x-4">
            <button className="px-6 py-2 bg-cyan-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
              Save
            </button>
            <button className="px-6 py-2 bg-red-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
              Cancel
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-3 gap-6">
          {/* Hotel Information */}
          <div className="col-span-2 bg-white p-6 shadow rounded-lg">
            <h3 className="text-lg font-bold mb-4">Hotel Information</h3>
            <div className="grid gap-4">
              <input className="w-full border p-2 rounded" type="text" placeholder="Name" />
              <input className="w-full border p-2 rounded" type="text" placeholder="Location" />
              <input className="w-full border p-2 rounded" type="text" placeholder="Geolocation" />
              <textarea
                className="w-full border p-2 rounded"
                placeholder="Address"
                rows="3"
              ></textarea>
            </div>
          </div>

          {/* Tax Information */}
          <div className="bg-white p-6 shadow rounded-lg">
            <h3 className="text-lg font-bold mt-10 mb-2">Tax Information</h3>
            <div className="grid gap-4">
              <input className="w-full border p-2 rounded" type="text" placeholder="Tax Code" />
              <div className="flex items-center gap-2">
                <input
                  className="w-full border p-2 rounded"
                  type="number"
                  placeholder="Tax Rate %"
                />
              </div>
              <div className="flex justify-between gap-4">
                <button className="bg-cyan-500 text-white px-4 py-2 rounded w-full">Save</button>
                <button className="bg-red-500 text-white px-4 py-2 rounded w-full">Cancel</button>
              </div>
            </div>
          </div>
        </div>

        {/* Total Hotels */}
        <div className="mt-12 mb-12 bg-white p-6 shadow rounded-lg flex items-center justify-center">
          <h3 className="text-lg font-bold">Total Hotels</h3>
          <span className="text-4xl font-bold ml-2">12</span>
        </div>
      </div>
    </div>
  );
}

export default HotelConfig;
